<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                company_id: '',
                capture_line: '',
                capture_line_two: '',
                statement: '',
                amount: '',
                date: '',
                deadline: '',
                type_taxes_id: '',
                type_payment_id: '',
                checkbook_id: '',
                folio: '',
            },
            capture_line: '',
            capture_line_name: '',
            capture_line_two: '',
            capture_line_name_two: '',
            statement: '',
            statement_name: '',
            send: false,
            load: false,
        }
    },
    methods: {
        async getFolioCheckbook() {
            if (!this.form.checkbook_id) {
                this.form.folio = '';
                return;
            }
            await this.catalogue.getFoliosCheckbooks(this.form.checkbook_id, this.folioUsed);
        },
        async get_checkbooks_company(){
            if(!this.form.company_id){
                return;
            }
            this.catalogue.get_checkbooks_company(this.form.company_id);

        },
        closedModal() {
            this.form.id = '';
            this.form.company_id = '';
            this.form.capture_line = '';
            this.form.capture_line_two = '';
            this.form.statement = '';
            this.form.amount = '';
            this.form.date = '';
            this.form.deadline = '';
            this.form.type_taxes_id = '';
            this.form.type_payment_id = '';
            this.capture_line = '';
            this.capture_line_name = '';
            this.capture_line_two = '';
            this.capture_line_name_two = '';
            this.statement = '';
            this.statement_name = '';
            this.form.checkbook_id = '';
            this.form.folio = '';
            this.send = false;
            this.load = false;

            this.$modal.hide('addTax');
        },
        catch_capture_line_two(event) {
            if (event.target.files[0].type == "application/pdf") {
                this.form.capture_line_two = event.target.files[0];
                this.capture_line_name_two = event.target.files[0].name;
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos PDF',
                });
            }
        },
        catch_capture_line(event) {
            if (event.target.files[0].type == "application/pdf") {
                this.form.capture_line = event.target.files[0];
                this.capture_line_name = event.target.files[0].name;
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos PDF',
                });
            }
        },
        catch_statement(event) {
            if (event.target.files[0].type == "application/pdf") {
                this.form.statement = event.target.files[0];
                this.statement_name = event.target.files[0].name;
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos PDF',
                });
            }
        },
        async saveTaxes() {
            this.send = true;

            const data_form = new FormData();
            data_form.append('id', this.form.id)
            data_form.append('company_id', this.form.company_id)
            data_form.append('capture_line', this.form.capture_line)
            data_form.append('capture_line_two', this.form.capture_line_two)
            data_form.append('statement', this.form.statement)
            data_form.append('amount', this.form.amount)
            data_form.append('date', this.form.date)
            data_form.append('deadline', this.form.deadline)
            data_form.append('type_taxes_id', this.form.type_taxes_id)
            data_form.append('type_payment_id', this.form.type_payment_id)
            data_form.append('checkbook_id', this.form.checkbook_id)
            data_form.append('folio', this.form.folio)



            let _endpoint = '/taxes';
            if (this.form.id != "") {
                data_form.append('_method', 'PUT');
                _endpoint = `/taxes/${this.form.id}`;
            }

            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    this.send = false;
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-taxes');
                }
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }

        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-addTaxes", async (tax) => {
            console.log(tax);
            if (tax.id) {
                this.form.id = tax.id;
                this.form.company_id = tax.company_id;
                this.form.amount = tax.amount;
                this.form.date = tax.date;
                this.get_checkbooks_company();                
                if (tax.checkbook_id_prev) {
                    this.form.checkbook_id = tax.checkbook_id_prev;
                    this.getFolioCheckbook();
                }

                if (tax.folio_prev) {
                    this.form.folio = tax.folio_prev;
                }
                if (tax.deadline) {
                    this.form.deadline = tax.deadline;
                }
                this.form.type_taxes_id = tax.type_taxes_id;
                this.file = tax.file;
                this.capture_line = tax.capture_line;
                if(tax.capture_line_two){
                    this.capture_line_two = tax.capture_line_two;
                }
                this.statement = tax.statement;
                this.form.type_payment_id = tax.type_payment_id;


            }
            this.$modal.show('addTax');

        })
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
    async mounted() {
        this.catalogue.get_companies_buildings();
        this.catalogue.get_taxes_types();
        this.catalogue.get_type_payments();
    }
}
</script>
<template>
    <modal name="addTax" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveTaxes" method="post" id="formTax" enctype="multipart/form-data">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Información Impuesto</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-4">
                        <label>Línea de captura</label><br>
                        <div class="custom-file" :style="capture_line != '' ? 'width: 87%' : 'width: 100%'">
                            <input :disabled="!prop_edit" type="file" name="capture_line" class="custom-file-input"
                                :class="capture_line != '' ? 'pr-5' : ''" id="customFile" ref="file"
                                @change="catch_capture_line">
                            <label class="custom-file-label text-left" for="customFile">{{ capture_line_name }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${capture_line}`" v-if="capture_line != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.capture_line" class="text-danger">{{ errors.capture_line[0] }}</div>

                    </div>
                    <div class="col-md-4">
                        <label>Declaración</label><br>
                        <div class="custom-file" :style="statement != '' ? 'width: 87%' : 'width: 100%'">
                            <input :disabled="!prop_edit" type="file" class="custom-file-input"
                                :class="statement != '' ? 'pr-5' : ''" id="customFile" ref="file"
                                @change="catch_statement">
                            <label class="custom-file-label text-left" for="customFile">{{ statement_name }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${statement}`" v-if="statement != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.statement" class="text-danger">{{ errors.statement[0] }}</div>
                    </div>

                    <div class="col-md-4">
                        <label>Declaración 2</label><br>
                        <div class="custom-file" :style="capture_line_two != '' ? 'width: 87%' : 'width: 100%'">
                            <input :disabled="!prop_edit" type="file" class="custom-file-input"
                                :class="capture_line_two != '' ? 'pr-5' : ''" id="customFile" ref="file"
                                @change="catch_capture_line_two">
                            <label class="custom-file-label text-left" for="customFile">{{ capture_line_name_two }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${capture_line_two}`" v-if="capture_line_two != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.capture_line_two" class="text-danger">{{ errors.capture_line_two[0] }}</div>

                    </div>

                    <div class="col-md-4 mt-3">
                        <label>Empresa</label>
                        <select :disabled="!prop_edit" type="text" class="form-control" v-model="form.company_id" @change="get_checkbooks_company()"> 
                            <option v-for="(company, index) in catalogue.companies_buildings" :value="company.id"
                                :key="index">
                                {{ company.name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.company_id" class="text-danger">{{ errors.company_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-3">
                        <label>Fecha</label>
                        <date-picker v-model="form.date" :disabled="!prop_edit" required="required"
                            valueType="format"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-3">
                        <label>Fecha límite</label>
                        <date-picker v-model="form.deadline" :disabled="!prop_edit" required="required"
                            valueType="format"></date-picker>
                        <div v-if="errors && errors.deadline" class="text-danger">{{ errors.deadline[0] }}</div>
                    </div>

                    <div class="col-md-6 mt-3">
                        <label>Monto</label>
                        <money :disabled="!prop_edit" class="form-control" v-model="form.amount"></money>
                        <div v-if="errors && errors.amount" class="text-danger">{{ errors.amount[0] }}</div>
                    </div>

                    <div class="col-md-6 mt-3">
                        <label>Tipo</label>
                        <select :disabled="!prop_edit" type="text" class="form-control" v-model="form.type_taxes_id">
                            <option v-for="(type, index) in catalogue.taxes_types" :value="type.id" :key="index">
                                {{ type.name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.type_taxes_id" class="text-danger">{{ errors.type_taxes_id[0] }}
                        </div>
                    </div>

                    <!-- <div class="col-md-4 mt-3">
                        <label>Tipo de saldo</label>
                        <select type="text" :disabled="!prop_edit" class="form-control" v-model="form.type_payment_id">
                            <option v-for="(type_payment, index_type_payment) in catalogue.type_payments"
                                :value="type_payment.id" :key="index_type_payment">{{
        type_payment.name }}</option>
                        </select>
                        <div v-if="errors && errors.type_payment_id" class="text-danger">{{ errors.type_payment_id[0] }}
                        </div>
                    </div> -->

                    <div class="col-md-6 mt-2" v-if="form.type_payment_id == 6">
                        <label>Chequera</label>
                        <select type="text" class="form-control" v-model="form.checkbook_id" :disabled="!prop_edit"
                            @change="getFolioCheckbook()">
                            <option value=""> Sin chequera</option>
                            <option v-for="(check, index) in catalogue.checkbooks" :value="check.id" :key="index">
                                <span v-if="check.bank">
                                    {{ check.bank.name }} -
                                </span>
                                {{ check.name }} {{ check.id_ini }} / {{ check.id_end }}
                            </option>
                        </select>
                        <div v-if="errors && errors.checkbook_id" class="text-danger">{{ errors.checkbook_id[0] }}</div>
                    </div>

                    <div class="col-md-6 mt-2" v-if="form.type_payment_id == 6">
                        <label>Folio</label>
                        <select type="text" class="form-control" v-model="form.folio" :disabled="!prop_edit">
                            <option value=""> Sin folio</option>
                            <option v-for="(folio, index) in catalogue.folios_checkbooks" :value="folio" :key="index">
                                {{ folio }}
                            </option>

                        </select>
                        <div v-if="errors && errors.folio" class="text-danger">{{ errors.folio[0] }}</div>
                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit && send == false" type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Guardar
                        </button>
                        <button v-if="send" type="button" class="btn float-right btn-outline-success">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando                           
                        </button>
                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>

                </div>
            </div>
        </form>
    </modal>
</template>